var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReloadAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 12C2.75 6.89226 6.85617 2.75 12 2.75C14.9229 2.75 17.1619 3.89167 18.726 5.11743L16.9992 7.06201C16.8031 7.2828 16.7549 7.59808 16.8759 7.86741C16.9969 8.13674 17.2647 8.31 17.56 8.31H22C22.4142 8.31 22.75 7.97421 22.75 7.56V2.56C22.75 2.24855 22.5575 1.9695 22.2664 1.85889C21.9752 1.74828 21.646 1.82912 21.4392 2.06201L19.7236 3.99401C17.9653 2.59755 15.3884 1.25 12 1.25C6.02383 1.25 1.25 6.06774 1.25 12C1.25 12.4142 1.58579 12.75 2 12.75C2.41421 12.75 2.75 12.4142 2.75 12Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 12C22.75 11.5858 22.4142 11.25 22 11.25C21.5858 11.25 21.25 11.5858 21.25 12C21.25 17.1058 17.1058 21.25 12 21.25C9.69736 21.25 7.77634 20.1805 6.34706 18.9776L8.18636 16.943C8.38519 16.723 8.43578 16.4066 8.31546 16.1356C8.19514 15.8647 7.92648 15.69 7.63 15.69H3.11C2.69579 15.69 2.36 16.0258 2.36 16.44V21.44C2.36 21.7502 2.55101 22.0285 2.84053 22.1399C3.13005 22.2514 3.45832 22.1731 3.66636 21.943L5.34066 20.0909C6.93522 21.4427 9.19866 22.75 12 22.75C17.9342 22.75 22.75 17.9342 22.75 12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReloadAlt);
export default __webpack_public_path__ + "static/media/reload-alt.1ee8d0956d918fda25040f24305a117f.svg";
export { ForwardRef as ReactComponent };